import { removeNullableProperties } from '@/shared/lib/removeNullableProperties';
import { trackEvent } from '@/entities/sogu';
import { useExcursionFiltersTotalCount } from '@/entities/filter/store/composables/excursion/useExcursionFiltersTotalCount.ts';
import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import { excursionMapFilterDataToSogu } from '@/entities/filter/store/utils/excursion/ExcursionMapFilterDataToSogu.ts';
import type { CityInfo } from '@/shared/api/experience';
import type { ContextGeoSubject } from '@/shared/types/geography';

function pickTotalExperiences(geo: CityInfo): number {
  if ('excursions_count' in geo) {
    return geo.excursions_count ?? 0;
  }

  if ('experience_count' in geo) {
    return geo.experience_count ?? 0;
  }

  return 0;
}

export function useExcursionPageViewTracker() {
  const filterStore = useExcursionFiltersStore();
  const { totalCount } = useExcursionFiltersTotalCount(filterStore.state, filterStore.pageParams);

  const trackListingPageViewEvent = async (
    tagId: number | null,
    geoInfo: CityInfo,
    defaultSoguFields: ContextGeoSubject,
  ) => {
    const payload = removeNullableProperties({
      tag_id: tagId,
      total_experiences: pickTotalExperiences(geoInfo),
      filtered_experiences: totalCount.value,
      ...excursionMapFilterDataToSogu(filterStore.state),
    });

    return trackEvent('listing.pageview', { ...defaultSoguFields.soguStamp, ...payload });
  };

  return {
    trackListingPageViewEvent,
  };
}
